import React from "react";
import Typography from "@material-ui/core/Typography";
const Discount = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Discount
      </Typography>
      <Typography paragraph variant="h5">
        Apply discount on specific product during special event
      </Typography>
      <Typography paragraph variant="body1">
        Discount is one of the features under the Sales module to manage item
        discount prices for particular events like New Year, Big Sale, etc. It
        contains any information regarding the discount name, discount active
        duration, and discount type, such as discount price or free item.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the Discount list. It
        is displayed like a table that contains download functions, sort,
        filter, and global search on the header area, and contains data
        navigation and refresh function on the footer area. The data column that
        appears in this table list are listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Discount ID</b>
        <br />
        Indicates the ID of the Discount.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Discount Code</b>
        <br />
        Indicates the code of the Discount.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Discount Name</b>
        <br />
        Indicates the name of the Discount.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Start Date</b>
        <br />
        Indicates the active duration start date of the Discount.
      </Typography>
      <Typography paragraph variant="body1">
        <b>End Date</b>
        <br />
        Indicates the active duration end date of the Discount.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Discount Status</b>
        <br />
        Indicates the status of the Discount. There are 2 statuses: Active and
        Expired.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Discount Type</b>
        <br />
        Indicates the type of the Discount. There are 3 types: Price Discount,
        Buy X Get Y and Free Shipping.
      </Typography>
      <Typography paragraph variant="body1">
        Apart from the column appearing on the table list, there are more
        columns available on each row by clicking the expand button on the left
        side of each data.
      </Typography>
      <Typography paragraph variant="body1">
        Besides, there are 3 buttons that appear on each row of Discount data
        with specific conditions explained below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Edit Discount</b>
        <br />
        This button is used to edit the Discount data.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Discount Detail</b>
        <br />
        This button is used to navigate to the Discount detail in non-editable
        mode.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Delete Discount</b>
        <br />
        This button is used to delete the Discount data. The Discount data is
        undeletable once it have transactions.
      </Typography>
    </React.Fragment>
  );
};

export default Discount;
